"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UNM49Type;
(function (UNM49Type) {
    UNM49Type[UNM49Type["Global"] = 0] = "Global";
    UNM49Type[UNM49Type["Region"] = 1] = "Region";
    UNM49Type[UNM49Type["Subregion"] = 2] = "Subregion";
    UNM49Type[UNM49Type["Intermediate"] = 3] = "Intermediate";
    UNM49Type[UNM49Type["Country"] = 4] = "Country";
})(UNM49Type = exports.UNM49Type || (exports.UNM49Type = {}));
//# sourceMappingURL=m49.js.map